/******************
* Main config
*******************/

if (typeof FN == 'undefined') FN = {};


FN.config = {
  urls: {
    base: false,
    apiBase: false,
    newsletter: false,
    picturepuzzle: 'picture-puzzle',
    apiContactSubscribe: 'contacts/subscribe',
    apiContactUpdate: 'contacts/update',
    licensingBase: false
  },
  analytics: {
    siteID: 'tower-blog',
    addPlatformToEventLabel: false
  }
};

FN.config.setEnvironmentUrls = function (type) {
  var urls = { 'base': false, 'apiBase': false };
  var host = window.location.host;

  if (host.indexOf('website-tower') === 0) {
    // development
    urls.base = '/';
    urls.apiBase = 'http://website-api.test/';
    urls.newsletter = 'http://website-api.test/contacts/subscribe';
    urls.licensingBase = 'https://staging.account.git-tower.com/api/';
  } else if (host.indexOf('staging.git-tower.com') === 0) {
    // staging
    urls.base = '/';
    urls.apiBase = 'https://staging.git-tower.com/api/';
    urls.newsletter = 'https://staging.git-tower.com/api/contacts/subscribe';
    urls.licensingBase = 'https://staging.account.git-tower.com/api/';
  } else {
    // production
    urls.base = '/blog/';
    urls.apiBase = 'https://www.git-tower.com/api/';
    urls.newsletter = 'https://www.git-tower.com/api/contacts/subscribe';
    urls.licensingBase = 'https://account.git-tower.com/api/';
  }

  FN.config.urls.base = urls.base;
  FN.config.urls.apiBase = urls.apiBase;
  FN.config.urls.newsletter = urls.newsletter;
  FN.config.urls.licensingBase = urls.licensingBase;
}
FN.config.setEnvironmentUrls();

FN.config.analyticsEvents = [
  /* Newsletter Subscription */
  {
    'config': { 'selector': '#after-download-modal .newsletter-form.analytics--submit', 'triggerOnlyOnce': true },
    'event': { 'eventCategory': 'newsletter', 'eventAction': 'signup', 'eventLabelSuffix': 'trial-download' }
  },
  {
    'config': { 'selector': '#trial-via-email .newsletter-form.analytics--submit', 'triggerOnlyOnce': true },
    'event': { 'eventCategory': 'newsletter', 'eventAction': 'signup', 'eventLabelSuffix': 'trial-via-email' }
  },
  /* Trial Download Buttons */
  {
    'config': { 'selector': '.nav-top-download .visible-on--mac .button--start-trial.analytics--click' },
    'event': { 'eventCategory': 'sales', 'eventAction': 'trial-download-mac', 'eventLabelSuffix': 'top-navi' }
  },
  {
    'config': { 'selector': '.nav-top-download .visible-on--windows .button--start-trial.analytics--click' },
    'event': { 'eventCategory': 'sales', 'eventAction': 'trial-download-windows', 'eventLabelSuffix': 'top-navi' }
  },
  /* Twitter */
  {
    'config': { 'selector': '#after-subscribe-modal .button--twitter.analytics--click' },
    'event': { 'eventCategory': 'social', 'eventAction': 'share', 'eventLabelSuffix': 'twitter' }
  }
];


/**
* Popup Configuration
*
* NOTE that additional popup configurations might be controlled by A/B Tests via Google Optimize!
*/
FN.popupConfig.addPopupConfig({
  'id': 'fn-popup-shirtgiveaway',
  'type': 'sidebar',
  'active': false,
  'pagePaths': ['.*'],
  'display': {
    'event': 'onLoad',
    'delay': '1500',
    'startSmall': true
  },
  'content': [
    {
      'type': 'content',
      'text': 'Get Your<br />Free T-Shirt',
      'action-button': 'Enter to Win'
    },
    {
      'type': 'newsletter-signup',
      'text': 'Subscribe to our newsletter<br />for a chance to win!',
      'action-button': 'Subscribe',
      'signup-form': 7,
      'signup-medium': 'tower-blog',
      'signup-URI': 'fn-popup-shirtgiveaway',
      'tags': [
        { 'id': 'tower_newsletter', 'label': "Yes, send me the kit and sign me up for the Tower newsletter. It's free, it's sent infrequently, you can unsubscribe any time - and it's loved by over <b>100,000 developers & designers</b>!", 'default': false, 'hidden': false, 'required': true, 'collectConsent': true }
      ],
      'consent': [
        { 'id': 'legal', 'required': true, 'text': 'I have read and accept the <a href="https://www.git-tower.com/legal/privacy-policy" target="_blank">Privacy Policy</a>. <br/>I understand that I can unsubscribe at any time.' }
      ]
    },
    {
      'type': 'tweet',
      'text': '<span class="fn-popup__text--line1">Double Your Chances!</span><br /><span class="fn-popup__text--line2">Tweet and get a second chance to win.</span>',
      'action-button': 'Tweet Now',
      'tweet': { 'platform': 'twitter', 'url': 'http://www.git-tower.com/', 'text': 'Tower - version control with Git made easy. Try the best Git client free for 30 days. #gittower ' }
    }
  ]
});
FN.popupConfig.addPopupConfig({
  'id': 'fn-popup-towerspecial',
  'type': 'sidebar',
  'active': false,
  'pagePaths': ['.*'],
  'display': {
    'event': 'onLoad',
    'delay': 500
  },
  'content': [
    {
      'type': 'link',
      'text': 'TOWER is <span style="font-weight:bold; color:#FCC026">25%</span> off - this week only!',
      'action-button': 'Learn More',
      'url': 'https://www.git-tower.com/?utm_source=Tower-Blog&amp;utm_medium=Popup&amp;utm_content=Popup-Tower-Sale&amp;utm_campaign=Tower-Sale-Special'
    }
  ]
});
FN.popupConfig.addPopupConfig({
  'id': 'fn-popup-black-friday-2018',
  'type': 'sidebar',
  'active': false,
  'pagePaths': ['.*'],
  'display': {
    'event': 'onLoad',
    'delay': 500
  },
  'content': [
    {
      'type': 'link',
      'text': '<a href="https://www.git-tower.com/?utm_source=Tower-Blog&amp;utm_medium=Popup&amp;utm_content=Popup-Black-Friday-2018&amp;utm_campaign=Black-Friday-2018"><img src="' + FN.config.urls.base + 'assets/img/popups/black-friday-50percent-special@2x.png" width="300" height="355" /></a>',
      'action-button': 'Get It Now',
      'url': 'https://www.git-tower.com/?utm_source=Tower-Blog&amp;utm_medium=Popup&amp;utm_content=Popup-Black-Friday-2018&amp;utm_campaign=Black-Friday-2018'
    }
  ]
});

/*** On-Click Incentive Popups */
FN.popupConfig.addPopupConfig({
  'id': 'fn-popup_incentive_cheatpackage',
  'type': 'modal',
  'active': true,
  'pagePaths': ['.*'],
  'display': {
    'event': 'onClick',
    'selector': '.button--incentive_cheatpackage',
    'showOnlyOnce': false
  },
  'content': [
    {
      'type': 'newsletter-signup',
      'text': '<h2 class="fn-popup__text--headline">Download the Cheat Sheet<span class="fn-popup__text--tag">Free</span></h2><p class="fn-popup__text--subline">Get 16 of our most popular Cheat Sheets in one handy ZIP!</p><span class="fn-popup__image"><img src="' + FN.config.urls.base + 'assets/img/popups/cheat-sheet-package@2x.png" width="210" /></span>',
      'action-button': 'Get the Package',
      'signup-form': 7,
      'signup-medium': 'tower-blog',
      'signup-URI': 'fn-popup_incentive_cheatpackage',
      'tags': [
        { 'id': 'tower_newsletter', 'label': "Yes, send me the package and sign me up for the Tower newsletter. It's free, it's sent infrequently, you can unsubscribe any time - and it's loved by over <b>100,000 developers & designers</b>!", 'default': false, 'hidden': false, 'required': true, 'collectConsent': true },
        { 'id': 'incentive_cheatpackage', 'label': "", 'default': true, 'hidden': true, 'collectConsent': false }
      ],
      'consent': [
        { 'id': 'legal', 'required': true, 'text': 'I have read and accept the <a href="https://www.git-tower.com/legal/privacy-policy" target="_blank">Privacy Policy</a>. <br/>I understand that I can unsubscribe at any time.' }
      ]
    },
    {
      'type': 'tweet',
      'text': '<h2 class="fn-popup__text--headline">Thanks! Please Check Your Inbox!</h2><p class="fn-popup__text--subline">Want to win one of our awesome Tower shirts?<br><b>Tell your friends about the cheat sheets!</b></p><span class="fn-popup__image"><img src="' + FN.config.urls.base + 'assets/img/popups/tower-shirts@2x.png" width="360" loading="lazy" /></span>',
      'action-button': 'Share on Twitter',
      'footer': 'We\'ll pick 4 winners every month who share this tweet!<br>Follow <a href="https://x.com/gittower" target="_blank">@gittower</a> to be notified if you win!',
      'tweet': { 'platform': 'twitter', 'url': 'http://www.git-tower.com/learn/', 'text': "Learn version control with Git for free - with awesome online books, videos & tutorials. #learngit " }
    }
  ]
});
FN.popupConfig.addPopupConfig({
  'id': 'fn-popup_incentive_workflow-of-vcs',
  'type': 'modal',
  'active': true,
  'pagePaths': ['.*'],
  'display': {
    'event': 'onClick',
    'selector': '.button--incentive_workflow-of-vcs',
    'showOnlyOnce': false
  },
  'content': [
    {
      'type': 'newsletter-signup',
      'text': '<h2 class="fn-popup__text--headline">Download this Guide<span class="fn-popup__text--tag">Free</span></h2><p class="fn-popup__text--subline">Get this guide as a high-quality PDF for free!</p><span class="fn-popup__image"><img src="' + FN.config.urls.base + 'assets/img/popups/cheat-sheet-package@2x.png" width="210" /></span>',
      'action-button': 'Get the Guide',
      'signup-form': 7,
      'signup-medium': 'tower-blog',
      'signup-URI': 'fn-popup_incentive_workflow-of-vcs',
      'tags': [
        { 'id': 'tower_newsletter', 'label': "Yes, send me the guide and sign me up for the Tower newsletter. It's free, it's sent infrequently, you can unsubscribe any time - and it's loved by over <b>100,000 developers & designers</b>!", 'default': false, 'hidden': false, 'required': true, 'collectConsent': true },
        { 'id': 'incentive_workflow-of-vcs', 'label': "", 'default': true, 'hidden': true, 'collectConsent': false }
      ],
      'consent': [
        { 'id': 'legal', 'required': true, 'text': 'I have read and accept the <a href="https://www.git-tower.com/legal/privacy-policy" target="_blank">Privacy Policy</a>. <br/>I understand that I can unsubscribe at any time.' }
      ]
    },
    {
      'type': 'tweet',
      'text': '<h2 class="fn-popup__text--headline">Thanks! Please Check Your Inbox!</h2><p class="fn-popup__text--subline">Want to win one of our awesome Tower shirts?<br><b>Tell your friends about the guide!</b></p><span class="fn-popup__image"><img src="' + FN.config.urls.base + 'assets/img/popups/tower-shirts@2x.png" width="360" loading="lazy" /></span>',
      'action-button': 'Share on Twitter',
      'footer': 'We\'ll pick 4 winners every month who share this tweet!<br>Follow <a href="https://x.com/gittower" target="_blank">@gittower</a> to be notified if you win!',
      'tweet': { 'platform': 'twitter', 'url': 'http://www.git-tower.com/learn/', 'text': "Learn version control with Git for free - with awesome online books, videos & tutorials. #learngit " }
    }
  ]
});






$(document).ready(function () {
  /*********** Configure Analytics Event Tracking */
  var defaultAnalyticsEvents = [
    /* Page Links */
    {
      'config': { 'selector': 'nav .tower-site-link.analytics--click', 'waitBeforeDefault': true },
      'event': { 'eventCategory': 'page-interaction', 'eventAction': 'landing-page', 'eventLabelSuffix': 'navigation/tower-website' }
    }
  ];
  FN.analytics.addConfiguredEvents(defaultAnalyticsEvents);
  FN.analytics.addConfiguredEvents(FN.config.analyticsEvents);

  /*********** prefill "source[OS]" value in newsletter forms */
  if ($('input[name="signup[OS]"]').length > 0) {
    $('input[name="signup[OS]"]').val(FN.helpers.platform());
  }


  /*********** newsletter subscription */
  $('.' + FN.newsletterConfig.selectors.formClass).each(function (index, element) {
    FN.newsletterConfig.instances.push(new FN.newsletter(element));
  });


  /*********** mobile navigation toggle */
  $('#nav-toggle').on('click', function () {
    $('#tower-claim').toggle();
    var navDisplay = ($('#tower-claim').is(':visible')) ? 'none' : 'table-cell';
    $('nav ul').css('display', navDisplay);
  });
});
